import dayjs from "dayjs";
import store from "@/store";
import constants from "@/config/constants";

import profileServices from "@/services/profile";
import organizationServices from "@/services/organization";

export function arrayToObject(array) {
  const object = {};
  array.forEach((d) => {
    const fieldType = constants.FIELD_TYPES.find((type) => type.key === d.type);
    object[d.key] = fieldType?.default || null;
  });
  return JSON.parse(JSON.stringify(object));
}

export function convertPayloadData(type, data, oldData = { extra: {}}) {
  const allConfigs = store.getters["config/allConfigs"];
  let config = null;
  if (!["files", "user_roles", "roles"].includes(type)) {
    config = allConfigs.find(
      (c) => c.extra.key === type
    );
  }

  if (config) {
    const fields = config?.extra?.fields || [];
    const fieldKeys = fields.map((f) => f.key);
    Object.keys(data.extra).forEach((key) => {
      if (![...constants.BLOCK_KEYS, ...fieldKeys].includes(key)) {
        delete data.extra[key];
      }
    });
    fields.forEach((field) => {
      if (!data.extra[field.key]) {
        const fieldType = constants.FIELD_TYPES.find(
          (f) => f.key === field.type
        );
        data.extra[field.key] = fieldType?.default;
      } else if ([
        constants.FIELD_TYPE.MULTIPLE_SELECT,
        constants.FIELD_TYPE.FILE_IMAGES,
        constants.FIELD_TYPE.FILE_VIDEOS,
        constants.FIELD_TYPE.FILE_AUDIOS,
        constants.FIELD_TYPE.FILE_OTHERS,
        constants.FIELD_TYPE.LINK_3DS,
        constants.FIELD_TYPE.LINK_YOUTUBE
      ].includes(field.key)) {
        if (Array.isArray(data.extra[field.key])) {
          const oldValue = oldData.extra[field.key] || []
          data.extra[field.key] = [...oldValue, ...data.extra[field.key]]
        } else {
          data.extra[field.key] = []
        }
      }
    });
  }

  const currentOrg = organizationServices.getCurrentOrg();

  return {
    ...data,
    type: type,
    code: data.code || "",
    creator_id: data.creator_id || "",
    register_at: data.register_at || dayjs(),
    tag_ids: data.tag_ids || [],
    status: data.status || "",
    ordered: data.ordered || 0,
    avatar_url: data.avatar_url || "",
    organization_id: currentOrg.id,
  };
}

export function notification(seft, type, actionType, name) {
  let message = "";
  let lastMessage = "";
  switch (actionType) {
    case "create":
      message = `Thêm mới ${name}`;
      break;
    case "update":
      message = `Cập nhật ${name}`;
      break;
    case "config":
      message = `Cấu hình ${name}`;
      break;
    case "delete":
      message = `Xoá ${name}`;
      break;
    default:
      message = name
      break;
  }
  switch (type) {
    case "success":
      lastMessage = "thành công";
      break;
    default:
      lastMessage = "thất bại";
      break;
  }
  seft.$notify({
    title: "Thông báo",
    message: message + " " + lastMessage,
    type,
  });
}

export async function fileToBase64(file) {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error); // Bắt lỗi nếu có
  });
}

export async function downloadFile(url, filename) {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(blobUrl);
}

export function checkPermission(actionKey, method) {
  if (!actionKey || !method) {
    return true;
  }
  const profiles = profileServices.getProfiles();
  if (profiles?.is_super_admin) {
    return true
  }

  const currentOrg = organizationServices.getCurrentOrg();
  if (currentOrg?.management_role_allow_all) {
    return true
  }
  if (currentOrg) {
    const action = currentOrg.management_role_actions[actionKey];
    return action ? action[method]?.allowed : false;
  }
  return false
}

export function convertConfig(config, module) {
  const fields = config.extra?.fields || [];
  const groups = config.extra?.groups || [];
  if (module) {
    const groupKeys = module.groups || [];
    const moduleGroups = groups.filter((g) => groupKeys.length > 0 ? groupKeys.includes(g.key) : true)
    const fieldKeys = [...new Set(groups.map((g) => g.fields).flat())];
    const moduleFields = fields.filter((f) => f.type === constants.FIELD_TYPE.MODULE || (fieldKeys.length > 0 ? fieldKeys.includes(f.key) : true));
    return {
      ...config,
      extra: {
        ...config.extra,
        groups: moduleGroups,
        fields: moduleFields
      }
    }
  }
  return config
}
